export default {
  formInputHeight: "3.15rem",
  formInputBorderRadius: "0.75rem",
};
